import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-download-media',
  templateUrl: './download-media.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DownloadMediaComponent implements OnInit {
  @Input() items: any;
  backendURL: string = null;
  constructor(private meta: Meta) {}

  ngOnInit() {
    const occURL = this.meta.getTag('name=occ-backend-base-url');
    this.backendURL = occURL.content;
  }
}
